import {
    productCode118,
    productCodeBamboo,
    productCodeBudgetMoney,
    productCodeCoopPlata,
    productCodePlata,
} from '@mediaingenuity/totallymoney.cardloanutils'

export const supportedSameDayDepositLoanIds = [
    productCode118,
    productCodeBamboo,
    productCodeBudgetMoney,
    productCodeCoopPlata,
    productCodePlata,
]

export const canShowSameDayDepositBadge = (loanId: string) =>
    supportedSameDayDepositLoanIds.includes(loanId)
